module.exports = __webpack_public_path__ + "static/media/p208ndihma.47c4fe12.jpg";